export const SET_IMAGE_CROP = 'imageCrop/SET_IMAGE_CROP';
export const RESET_IMAGE_CROP = 'imageCrop/RESET_IMAGE_CROP';
export const SET_CROPPED_COVER = 'imageCrop/SET_CROPPED_COVER';
export const SET_CROP_FOR_NEW_IMAGE = 'imageCrop/SET_CROP_FOR_NEW_IMAGE';
export const HANDLE_SIZE_CHANGE = 'imageCrop/HANDLE_SIZE_CHANGE';
export const SEND_IMAGE_TO_SERVER = 'imageCrop/SEND_IMAGE_TO_SERVER';
export const ROTATE_IMAGE = 'imageCrop/ROTATE_IMAGE';
export const SET_CROP_RATIO = 'imageCrop/SET_CROP_RATIO';
export const SET_SAVING_IMAGE_ERROR = 'imageCrop/SET_SAVING_IMAGE_ERROR';
